import ContactUnlinkedConflict from './../models/ContactUnlinkedConflict';
import Base from './Base';

export default class ContactsUnlinkedConflict extends Base {
    get models() {
        const collection = this.data.map(item => new ContactUnlinkedConflict(item));
        collection.collection = this;

        return collection;
    }
}
